import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, finalize, map, mergeMap, tap } from 'rxjs/operators';

import { of } from 'rxjs';
import {
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    addRecord,
    addRecordSuccess,
    addRecordFailure,
    updateRecord,
    updateRecordSuccess,
    updateRecordFailure,
    deleteRecord,
    deleteRecordSuccess,
    deleteRecordFailure,
    fetchSingleRecord,
    fetchSingleRecordSuccess,
    fetchSingleRecordFail,
    resendInvitation,
    resendInvitationSuccess,
    resendInvitationFailure,
    resetTwoFactor,
    resetTwoFactorSuccess,
    resetTwoFactorFailure,
    fetchActivities,
    fetchActivitiesSuccess,
    fetchActivitiesFail,
    loginAsUser,
    loginAsUserSuccess,
    loginAsUserFailure
} from './users.action';

import {
    fetchRecordsSuccess as fetchRecordsSuccessRole,
} from '../Roles/roles.action';


import { AlertService } from 'src/app/core/services/alert.service';
import { CrudServerService } from 'src/app/core/services/crud-server.service';
import { RouterService } from 'src/app/core/services/router.service';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { UsersTableService } from './users-table.service';
import { DatatableService } from 'src/app/core/services/datatable.service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { currentUser } from '../Authentication/authentication.actions';
import { HelperService } from 'src/app/core/services/helper.service';
import { environment } from 'src/environments/environment';
import { ActivityTableService } from './activity-table.service';


@Injectable()
export class UsersRecordEffects {

    fetchData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchRecords),
            mergeMap(() => {
                const url = 'users';
                return this.crudServerService.fetchTableData(url, this.moduleTableService).pipe(
                    map( (response) => {
                        const data = response.data;
                        const listData = data.records;
                        const total = data.pagination.total;
                        const roles = data.roles;
                        const accesses = data.accesses;

                        this.moduleTableService.page = data.pagination.current_page;
                        this.moduleTableService.lastPage = data.pagination.last_page;
                        this.moduleTableService.pagination = this.tableService.getPaginationArray(data.pagination.current_page, data.pagination.last_page)
                        
                        this.moduleTableService.accesses = accesses;
                        this.moduleTableService.roles = roles;

                        this.alertService.triggerAlert(response.message, "success");
                        return fetchRecordsSuccess({listData: listData, total});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => fetchRecordsFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    fetchActivities$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchActivities),
            exhaustMap((data: any) => {
                const url = 'activities/'+data.id;
                return this.crudServerService.fetchTableData(url, this.activityTableService).pipe(
                    map( (response) => {

                        const data = response.data;
                        const listData = data.records;
                        const total = data.pagination.total;
                        const actions = data.actions;

                        this.activityTableService.page = data.pagination.current_page;
                        this.activityTableService.lastPage = data.pagination.last_page;
                        this.activityTableService.pagination = this.tableService.getPaginationArray(data.pagination.current_page, data.pagination.last_page)
                        
                        this.activityTableService.actions = actions;


                        this.alertService.triggerAlert(response.message, "success");
                        return fetchActivitiesSuccess({activities: listData, totalActivity: total});
                    }),
                    
                    catchError((activity_error) =>
                        of(activity_error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(activity_error, "error");
                            }),
                            map(() => fetchActivitiesFail({ activity_error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    addData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(addRecord),
            exhaustMap((data: any) => {
                const url = 'users';
                return this.crudServerService.addData(url, data.newData).pipe(

                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        this.routeService.triggerRoute(response, "/users");
                        return addRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => addRecordFailure({ error })) // Dispatch 
                        )
                    ),

                    finalize(() => {
                        this.helperService.formButtonDisabled = false;
                    })
                )
            })
        )
    );
    
    fetchSingle$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchSingleRecord),
            exhaustMap((data: any) => {
                const url = 'users/'+data.id+"/edit";
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");

                        this.store.dispatch(fetchRecordsSuccessRole({ listData: response.data.roles, total: 0 }));

                        return fetchSingleRecordSuccess({singleData: response.data.user});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                                this.routeService.triggerRoute(null, "/users");
                            }),
                            map(() => fetchSingleRecordFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    updateData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateRecord),
            exhaustMap((data:any) => {
                const url = 'user-update/'+data.id;
                return this.crudServerService.updateDataPost(url, data.updatedData).pipe(
                    map( (response) => {

                        const user: any = this.localStorageService.getItem('currentUser');

                        if(user.id === data.id){ //IF current user is getting updated
                            this.store.dispatch(currentUser());
                        }

                        this.alertService.triggerAlert(response.message, "success");
                        this.routeService.triggerRoute(response, "/users");
                        return updateRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => updateRecordFailure({ error })) // Dispatch 
                        )
                    ),

                    finalize(() => {
                        this.helperService.formButtonDisabled = false;
                    })
                )
            })
        )
    );

    deleteData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(deleteRecord),
            exhaustMap((data: any) => {
                const url = 'users/'+data.id;
                return this.crudServerService.deleteData(url).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        this.store.dispatch(fetchRecords());
                        this.routeService.triggerRoute(null, "/users");
                        return deleteRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => deleteRecordFailure({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );
    
    resendInvitation$ = createEffect(() =>
        this.actions$.pipe(
            ofType(resendInvitation),
            exhaustMap((data: any) => {
                const url = 'resend-invitation/'+data.id+'/1';
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        return resendInvitationSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => resendInvitationFailure({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    loginAsUser$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loginAsUser),
            exhaustMap((data: any) => {
                const url = 'login-contributie-user/'+data.id;
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {

                        const data = response.data;
                        const url = environment.contributie+'/auth/apply-login'+data.access_url;
                        // console.log(url);
                        window.location.replace(url);

                        return loginAsUserSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => loginAsUserFailure({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    resetTwoFactor$ = createEffect(() =>
        this.actions$.pipe(
            ofType(resetTwoFactor),
            exhaustMap((data: any) => {
                const url = 'reset-two-factor/'+data.id;
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        return resetTwoFactorSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => resetTwoFactorFailure({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );
   
    constructor(
        private actions$: Actions,
        private crudServerService: CrudServerService,
        private alertService: AlertService,
        private routeService: RouterService,
        private store: Store<RootReducerState>,
        private moduleTableService: UsersTableService,
        private tableService: DatatableService,
        private localStorageService: LocalStorageService,
        private activityTableService: ActivityTableService,
        public helperService: HelperService
    ) { }

}